package com.example.mystybag.common.views

import androidx.compose.runtime.Composable
import com.example.mystybag.core.logic.base.BaseViewModel
import com.example.mystybag.core.logic.base.EmptyViewModel
import com.example.mystybag.common.logic.ChooseCountryViewModel
import com.example.mystybag.common.logic.InternetTroubleshootingViewModel

@Composable
fun CommonViews(viewModel: BaseViewModel) {
    when (viewModel) {
        is InternetTroubleshootingViewModel -> InternetTroubleshootingView(viewModel)
        is ChooseCountryViewModel           -> ChooseCountryView(viewModel)
        is EmptyViewModel                   -> { }
    }
}